import { PathSegments } from '../../abstract/path-segments';

/** `organizations/{id}` as path segments, for org-scoped routes (`{ prefix: orgPrefix(id) }`). */
export function orgPrefix(organizationId: string): PathSegments {
  return ['organizations', organizationId];
}
